import { getParentsClasses } from './getParentsClasses';

const ignoreClasses = [
    'skip-to-main',
];

export const returnFocus = (
    element: Element,
    _returnFocus: boolean = true,
) => {
    const classes = getParentsClasses(
        element as HTMLElement,
        ignoreClasses
    );
    let returnFocus = _returnFocus;
    for (let i = 0; i < ignoreClasses.length; i++) {
        if (classes.includes(ignoreClasses[i])) {
            returnFocus = false;
            break;
        }
    }
    return returnFocus;
};
